import { Page, PageProps } from '@react-pdf/renderer';
import React from 'react';

export default function CustomPage({
  style,
  children,
  orientation = 'portrait',
  ...props
}: React.PropsWithChildren<PageProps>) {
  return (
    <Page
      style={[
        {
          padding: 15,
        },
        ...(Array.isArray(style) ? [...style] : [style || {}]),
        // { width: orientation === 'portrait' ? '297mm' : '420mm' },
      ]}
      orientation={orientation}
      {...props}
    >
      {/* <View debug wrap> */}
      {children}
      {/* </View> */}
    </Page>
  );
}
